import script from "./DonorsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./DonorsListView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__